import { useSelector } from "react-redux";
import { X, Check } from "lucide-react";
import TableHead from "../../../../components/UI/TableUI/TableHead";
import { checkValue } from "../../../../functions/checkValue";
import { siteCategoryColor } from "../../utils/siteHelpers";
import SiteActions from "./SiteActions";
import NoDataDisplay from "../../../../components/UI/NoDataDisplay";
import { hasAnyRole } from "../../../../utils/tableHeaderConfigh";
import { adminRoles } from "../../../../utils/adminRoles";
import UsePermissionsClaim from "../../../../CustomHooks/UsePermissionsClaim";
import sortDataByNumber from "../../../../functions/sorting/sortDataByNumber";

const SiteTableView = ({ setViewDialogDetails, filteredHeadList }) => {
  const sitesData = useSelector((state) => state.data.data);
  const isSorted = useSelector((state) => state.data.isSorted);
  const { checkPermission } = UsePermissionsClaim();
  const permAddSite = checkPermission("add_site");
  const permAddOperator = checkPermission("add_station_operator");

  const hasRole = hasAnyRole(adminRoles);
  const isDataAvailable = sitesData.length > 0;
  let siteList = isSorted ? sitesData : sortDataByNumber(sitesData, "id");

  return (
    <div className="table-container table-height scroll-area">
      <table className={`table ${!isDataAvailable ? "relative" : ""}`}>
        <tbody>
          <TableHead headList={filteredHeadList} />
          {isDataAvailable ? (
            <>
              {siteList.map((data, index) => {
                return (
                  <tr className="table-row [&_td]:p-3" key={index}>
                    <td>{data.id}</td>
                    <td className="text-left w-[7rem] whitespace-normal">
                      {data.name}
                    </td>
                    <td>{checkValue(data.machineID)}</td>
                    {hasRole && (
                      <td>
                        {checkValue(
                          data.jbccFieldTechnician.jbccSupervisor?.fullName,
                        )}
                      </td>
                    )}

                    <td>{checkValue(data.jbccFieldTechnician?.fullName)}</td>
                    <td>
                      {checkValue(data.jbccFieldTechnician?.mobileNumber)}
                    </td>
                    <td>{checkValue(data.je?.subDivision?.name)}</td>
                    <td>
                      {data.isAutomation ? (
                        <Check
                          color="green"
                          className="mx-auto"
                          strokeWidth={2.5}
                        />
                      ) : (
                        <X color="red" className="mx-auto" strokeWidth={2.5} />
                      )}
                    </td>
                    <td
                      className={`font-semibold ${siteCategoryColor(
                        data.category.name,
                      )}`}
                    >
                      {data.category.name}
                    </td>
                    <td>
                      <button
                        className="tableViewBtn"
                        onClick={() =>
                          setViewDialogDetails({ open: true, data: data })
                        }
                      >
                        View
                      </button>
                    </td>
                    {(permAddSite || permAddOperator) && (
                      <td>
                        <SiteActions
                          siteId={data.id}
                          siteName={data.name}
                          categoryId={data.category.id}
                          jbccFtId={data.jbccFieldTechnician?.id}
                          jnFtId={data.jnFieldTechnician?.id}
                          jeId={data.je.id}
                          machineId={data.machineID}
                        />
                      </td>
                    )}
                  </tr>
                );
              })}
            </>
          ) : (
            <NoDataDisplay />
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SiteTableView;
